"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.normalizeFormLayout = normalizeFormLayout;
exports.bmVariableLayout = bmVariableLayout;
exports.defaultModalAddOptions = exports.defaultBmVariableLayoutOpts = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var defaultBmVariableLayoutOpts = {
  hideAdd: false,
  addButtonLabel: 'Add',
  modalAdd: false,
  hideRemove: false,
  removeButtonLabel: 'Remove'
};
exports.defaultBmVariableLayoutOpts = defaultBmVariableLayoutOpts;
var defaultModalAddOptions = {
  headerLabel: 'Add',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel'
};
exports.defaultModalAddOptions = defaultModalAddOptions;

function normalizeFormLayout(info) {
  if (!('$each' in info)) {
    var _info = info,
        _formLayout = _info.formLayout;
    info = {
      $each: {
        default: info,
        formLayout: _formLayout
      }
    };
  }

  var formLayout = info.$each.formLayout;
  info.$each.default.formLayout = formLayout;
  if (info.$each.modalAdd) info.$each.modalAdd.layout.formLayout = formLayout;
  return info;
}

function bmVariableLayout(clazz) {
  var A = /*#__PURE__*/function (_clazz) {
    (0, _inherits2.default)(A, _clazz);

    var _super = (0, _createSuper2.default)(A);

    function A() {
      (0, _classCallCheck2.default)(this, A);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(A, [{
      key: "setDefaultOptions",
      value: function setDefaultOptions() {
        this.info.options = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, defaultBmVariableLayoutOpts), this.info.options);
      }
    }, {
      key: "addRow",
      value: function addRow() {
        this.dispatchEvent(new CustomEvent('addRow', {
          composed: true,
          bubbles: true,
          detail: {
            modalAdd: this.getModalAddOptions(this.info.options.modalAdd)
          }
        }));
      }
    }, {
      key: "getModalAddOptions",
      value: function getModalAddOptions(opt) {
        if (opt === null || opt === undefined || opt === false) return false;
        var overrideOpts = opt === true ? {} : opt;
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, defaultModalAddOptions), overrideOpts);
      }
    }, {
      key: "removeRow",
      value: function removeRow(evt, idx) {
        evt.stopPropagation();
        this.dispatchEvent(new CustomEvent('removeRow', {
          composed: true,
          bubbles: true,
          detail: {
            idx: idx
          }
        }));
      }
    }, {
      key: "shouldHideRemove",
      value: function shouldHideRemove(hideRemove, rowName) {
        hideRemove = hideRemove || false;

        var _hideRemove = typeof hideRemove === 'boolean' ? hideRemove : hideRemove[rowName];

        return _hideRemove;
      }
    }], [{
      key: "dependents",
      value: function dependents(layout) {
        return layout.options.order;
      }
    }]);
    return A;
  }(clazz);

  return A;
}
